// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CheckExperiment } = require('client-v2/common/containers/rollouts')
const useStickyfill = require('client-v2/common/hooks/stickyfill')
// Sibling imports
const TopCallToActionExplainerApp = require('./explainer-app-smart')
const TopCallToActionExplainerButtons = require('./explainer-buttons-smart')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionExplainer')

function TopCallToActionExplainerControl(props) {
  return tag('div', {
    ref: useStickyfill(),
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('heading')
    },
      `All your favorite things.\n`,
      `All in one place.`
    ),
    tag('div', {
      className: bem.element('subheading')
    },
      `Curate and share the best of the internet.\n`,
      `Mix learns what you love to show you even more.`
    ),
    tag(TopCallToActionExplainerApp),
    tag(TopCallToActionExplainerButtons)
  )
}

function TopCallToActionExplainerDiscover(props) {
  return tag('div', {
    ref: useStickyfill(),
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('heading', 'bold')
    },
      `Discover the\n`,
      `best of the web`
    ),
    tag('div', {
      className: bem.element('subheading')
    },
      `Mix shows you interesting content\n`,
      `selected by friends & like-minded people`
    ),
    tag(TopCallToActionExplainerApp),
    tag(TopCallToActionExplainerButtons)
  )
}

function TopCallToActionExplainer() {
  return tag(CheckExperiment, {
    experimentKey: '*logged_out_top_cta',
    renderWithModifier: modifier => {
      if (modifier === 'c') {
        return tag(TopCallToActionExplainerDiscover, {
          className: bem.block({ 'center-on': 'parent' })
        })
      }
      if (modifier === 'b') {
        return tag(TopCallToActionExplainerDiscover, {
          className: bem.block({ 'center-on': 'screen' })
        })
      }
      return tag(TopCallToActionExplainerControl, {
        className: bem.block({ 'center-on': 'screen' })
      })
    }
  })
}

module.exports = TopCallToActionExplainer
